import { Dispatch, SetStateAction } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import Typography from '@components/Typography';
import { Currencies } from '@constants/constants';
import CustomIcon from '@components/utils/CustomIcon';
import { ChevronRight, ClockIcon } from '@assets/icons';
import OriginalPrice from '@components/ui/price/OriginalPrice';
import {
  CloudinaryImageViewModel,
  FavoriteItemType,
  WishListItemViewModel,
  WishListViewModel,
} from '@api/v3';
import MyFavoriteComponent from '@components/views/my-favorites/MyFavoriteComponent';
import { useAuthState } from '@contexts/auth/AuthContext';
import { productImpression } from '@utils/newDataLayer/productImpression';

import {
  Container,
  Content,
  Header,
  TitleWrapper,
  PriceWrapper,
  Footer,
  ImageWrapper,
  Line,
  DiscountWrapper,
  FavoriteWrapper,
  PriceText,
  FlexContainer,
} from './styled';

type Props = {
  days?: string;
  title?: string;
  price?: number;
  link?: string;
  image?: CloudinaryImageViewModel;
  imageHeight?: string;
  discount?: number;
  tour?: any;
  favoriteLists?: WishListViewModel[];
  refetchFavoriteLists?: any;
  defaultList?: WishListViewModel;
  defaultListItems?: WishListItemViewModel[];
  refetchDefaultList?: any;
  isRedirectingSet?: Dispatch<SetStateAction<boolean>>;
};

const FeaturedTourItem = ({
  title,
  days,
  price,
  link,
  discount,
  imageHeight,
  image,
  tour,
  favoriteLists,
  refetchFavoriteLists,
  defaultList,
  defaultListItems,
  refetchDefaultList,
  isRedirectingSet,
}: Props) => {
  const loginInfo = useAuthState();
  return (
    <Container
      onClick={() => {
        productImpression({
          item_list_location: 'Anasayfa En Çok Tercih Edilen Turlar',
          item_list_id: tour?.city ? `${tour?.city} Turları` : tour?.title,
          type: 'tour',
        });
      }}
    >
      <ImageWrapper height={imageHeight}>
        <FavoriteWrapper>
          <MyFavoriteComponent
            itemId={tour?.id}
            itemName={tour?.title}
            imageUrl={image?.url ?? ''}
            type={FavoriteItemType.TOUR}
            isListing={true}
            itemUrl={tour?.url?.slice(1)}
            favoriteLists={favoriteLists}
            refetchFavoriteLists={refetchFavoriteLists}
            defaultList={defaultList}
            defaultListItems={defaultListItems}
            refetchDefaultList={refetchDefaultList}
            fontSize={24}
            fontColor={loginInfo.userInfo.id ? 'coral' : 'eclipse'}
            isHomePage={true}
            isFeaturedTour={true}
          />
        </FavoriteWrapper>
        <Link
          style={{
            position: 'relative',
            zIndex: 5,
            display: 'flex',
            width: 'auto',
          }}
          href={link ?? ''}
          title={tour?.title}
          onClick={() => isRedirectingSet?.(true)}
          prefetch={false}
        >
          <Image src={image?.url ?? ''} alt={image?.alt ?? tour?.title} fill />
        </Link>
      </ImageWrapper>
      <Content>
        {days ? (
          <Header>
            <CustomIcon icon={ClockIcon} paletteColor='R500' fontSize={14} />
            <Typography variant='caption2' weight='Regular' color='D100'>
              {days} Gün
            </Typography>
          </Header>
        ) : null}
        <TitleWrapper>
          <Typography variant='caption' weight='SemiBold' color='D400'>
            {title}
          </Typography>
        </TitleWrapper>

        <Footer>
          {discount ? (
            <>
              <Line />

              <DiscountWrapper>
                <Typography variant='caption' weight='Bold' color='R600'>
                  %{discount}
                </Typography>
                <Typography variant='caption3' weight='Bold' color='R600'>
                  İNDİRİM
                </Typography>
              </DiscountWrapper>
            </>
          ) : null}
          {price ? (
            <PriceWrapper>
              <OriginalPrice
                decimalShow={true}
                price={price ?? 0}
                currency={Currencies.TL}
                noLine
              />
              <PriceText>'den itibaren</PriceText>
            </PriceWrapper>
          ) : null}
          <FlexContainer>
            <Link
              title={title}
              href={link ?? ''}
              onClick={() => isRedirectingSet?.(true)}
              prefetch={false}
            >
              <CustomIcon icon={ChevronRight} fontSize={18} color='D400' />
            </Link>
          </FlexContainer>
        </Footer>
      </Content>
    </Container>
  );
};

export default FeaturedTourItem;
